module.exports = __webpack_public_path__ + "static/img/23d.db4ca0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23d.jpg
// module id = d+8L
// module chunks = 0